import { FuelRobDataTypeEnum } from './AolEnums';
import { FuelRobPerTank } from './FuelRobPerTank';

export class FuelRobData {
    type: FuelRobDataTypeEnum;
    hfoCorrectionInMt?: number;
    mgoCorrectionInMt?: number;
    fuelRobPerTanks: FuelRobPerTank[];
    portId: number;
    dateUtc: Date;
    eventDateTime?: Date;
    indexInDay: number;

    constructor(
        type: FuelRobDataTypeEnum,
        fuelRobPerTanks: FuelRobPerTank[],
        portId: number,
        dateUtc: Date,
        indexInDay: number,
        hfoCorrectionInMt?: number,
        mgoCorrectionInMt?: number,
        eventDateTime?: Date
    ) {
        this.type = type;
        this.hfoCorrectionInMt = hfoCorrectionInMt;
        this.mgoCorrectionInMt = mgoCorrectionInMt;
        this.fuelRobPerTanks = fuelRobPerTanks;
        this.portId = portId;
        this.dateUtc = dateUtc;
        this.eventDateTime = eventDateTime;
        this.indexInDay = indexInDay;
    }
}
